// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"7a45794b","112":"d7986630","418":"7366bc2a","460":"0716e276","552":"230f7ef8","787":"a2eff1e3","906":"abc64dd1"}[chunkId] + ".chunk.js";
};